import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-manage-content',
  templateUrl: './manage-content.component.html',
  styleUrls: ['./manage-content.component.css']
})
export class ManageContentComponent implements OnInit {

  containerForm: FormGroup;
  submitted = false;
  
  constructor(private formBuilder: FormBuilder) { }

      // convenience getter for easy access to form fields
      get f() { return this.containerForm.controls; }

  ngOnInit() {
    this.initForm();
  }

  initForm = () =>{
    this.containerForm = this.formBuilder.group({
      type: ['', Validators.required],
      order: ['', Validators.required], //, Validators.minLength(6)            
    });
  }

  search = (text$: Observable<string>) =>
  text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    // map(term => term.length < 2 ? []
    //   : this.childMenuItems.filter(v => v.tooltip.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
  )

}
